import React, { useContext } from 'react';
import NumberFormat from 'react-number-format';

// @material-ui/core components
import Typography from '@material-ui/core/Typography';

// mobx components
import { observer } from 'mobx-react';
import SavingCapacityStoreContext from '../../stores/SavingCapacityStore';

const TotalSavingCapacity = observer(({ lang }) => {
  const savingCapacityStore = useContext(SavingCapacityStoreContext);

  return (
    <div style={{ paddingTop: '20px' }}>
      {/* <p>Total de ingresos: {savingCapacityStore.incomes}</p>
      <p>Total de gastos: {savingCapacityStore.expenses}</p> */}
      {/* <p>: ${savingCapacityStore.capacity} </p> */}
      <Typography gutterBottom>
        {lang.savingTittle}{' '}
        <span
          style={{
            color: '#000',
            fontSize: '18px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            margin: '0px',
            fontWeight: '600',
          }}
        >
          <NumberFormat
            value={savingCapacityStore.incomes * 12}
            displayType="text"
            thousandSeparator
            prefix="$"
          />
          {/* ${savingCapacityStore.incomes} */}
        </span>
      </Typography>
      <Typography gutterBottom>
        {lang.savingTotalExpensive}{' '}
        <span
          style={{
            color: '#000',
            fontSize: '18px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            margin: '0px',
            fontWeight: '600',
          }}
        >
          <NumberFormat
            value={savingCapacityStore.expenses * 12}
            displayType="text"
            thousandSeparator
            prefix="$"
          />
          {/* ${savingCapacityStore.expenses} */}
        </span>
      </Typography>
      <Typography gutterBottom>
        {lang.savingDescription}
        {': '}
        <span
          style={{
            color: '#000',
            fontSize: '18px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            margin: '0px',
            fontWeight: '600',
          }}
        >
          <NumberFormat
            value={savingCapacityStore.capacity}
            displayType="text"
            thousandSeparator
            prefix="$"
          />
          {/* ${savingCapacityStore.capacity} */}
        </span>
      </Typography>
    </div>
  );
});

export default TotalSavingCapacity;
